<div class="bg-th-blue mt-0 container-fluid">
    <div class=" d-flex justify-content-between align-content-center">


        <i class="fa fa-arrow-left text-white my-auto pointer" (click)="goBack()"></i>
        <p class="text-white my-2 dirI d-flex align-items-center"><span>
              کاربران زیر مجموعه شما {{userNumber}}
            </span> <i class="fa fa-question-circle my-auto me-2 fa-2x pointer" (click)="guid(32)"></i></p>



    </div>
</div>
<div class=" d-flex align-items-center mt-3 flex-column container">
    <div class="d-flex col-12 justify-content-between flex-wrap">
        <div class=" mt-3 col-md-4 col-6" *ngFor="let item of user; index as i" (click)="getSingel(i)" data-bs-toggle="modal" data-bs-target="#exampleModal">
            <div class="col-11 card  rounded">
                <p class="bg-th-white f18 p-2 text-start">{{item.strFullName}}</p>
                <div class="px-1 mt-0">
                    <div class="d-flex justify-content-between">

                        <span>{{item.strMobile}}</span>
                        <p class="card-text text-start text-secondary mt-0">:شماره موبایل</p>
                    </div>
                    <div class="d-flex justify-content-between">
                        <span>{{item.strEshterakRegisterDate}}</span>
                        <p class="card-text text-start text-secondary mt-0">:تاریخ ثبت نام</p>
                    </div>

                </div>
            </div>

        </div>
    </div>


</div>
<!-- Button trigger modal -->


<!-- Modal -->
<div class="modal fade rtl " id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-xl">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel" *ngIf="user[index]">کاربر انتخاب شده :{{user[index].strFullName}}</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body " *ngIf="user[index]">
                <div class="d-flex justify-content-between">
                    <span class="text-secondary">تعداد خودرو ثبت شده با GPS : </span><span>{{user[index].iNumCarsWithGPS}}</span>

                </div>
                <div class="d-flex justify-content-between">

                    <p class="text-secondary">تعداد خودرو ثبت شده بدون GPS : </p><span>{{user[index].iNumCarsWithoutGPS}}</span>
                </div>



            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">بستن</button>

            </div>
        </div>
    </div>
</div>